import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMapPin } = FiIcons;

const About = () => {
  return (
    <section className="min-h-screen bg-[#FDFCF8] pt-40 pb-24" aria-labelledby="about-heading">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-accent-orange mb-6">
          About 7601 Canada
        </p>
        <h1 id="about-heading" className="text-5xl md:text-7xl font-serif font-black tracking-tight mb-8">
          A more comfortable way to stay in Orlando.
        </h1>
        <div className="max-w-2xl space-y-6 text-black/70 text-lg leading-relaxed">
          <p>
            7601 Canada Avenue is a professionally managed collection of premium Orlando suites for short- to mid-term stays.
          </p>
          <p>
            We help families and business travelers enjoy more space, full kitchens, pool-facing views, and a convenient location near International Drive, Universal Orlando, and the Orange County Convention Center.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mt-14">
          <a
            href="tel:+14073522400"
            className="border border-black/10 bg-white p-6 hover:border-accent-orange transition-colors"
          >
            <SafeIcon icon={FiPhone} className="text-accent-orange w-6 h-6 mb-4" />
            <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-black/40 mb-2">
              Contact us
            </p>
            <p className="font-bold text-lg">+1 (407) 352-2400</p>
          </a>
          <a
            href="https://www.google.com/maps/search/?api=1&query=7601+Canada+Avenue+Orlando+FL+32819"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-black/10 bg-white p-6 hover:border-accent-orange transition-colors"
          >
            <SafeIcon icon={FiMapPin} className="text-accent-orange w-6 h-6 mb-4" />
            <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-black/40 mb-2">
              Find us
            </p>
            <p className="font-bold text-lg">7601 Canada Avenue, Orlando</p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;